import React, { useMemo } from 'react';
import moment from 'moment';

import Divider from 'antd/es/divider';

import { Row, Col } from 'components/layout';

import ScheduleSection from '../components/ScheduleSection';
import ScheduleStepTitle from '../components/ScheduleStepTitle';
import ScheduleCalendar from '../components/ScheduleCalendar';

const BreakingTimesStep = ({ schedule, shifts, setShifts }) => {
  const periodDescription = useMemo(() => {
    if (schedule) {
      const validFrom = moment(schedule.valid_from).format('MMMM DD');
      const validTo = schedule.valid_to ? moment(schedule.valid_to).format('MMMM DD') : '...';
      return [validFrom, validTo].join(' - ');
    }
    return '';
  }, [schedule]);
  
  return (
    <Row>
      <Col span={24}>
        <ScheduleStepTitle
          title="Regular break times"
          description="Add regular breaks by clicking and dragging the time frame you want to add"
          style={{ padding: '16px 0' }}
        />
      </Col>
      <Col span={24}>
        <ScheduleSection
          title={periodDescription}
          style={{ marginBottom: '24px' }}
        >
          <Divider type="horizontal" style={{ marginTop: 0, marginBottom: '32px' }} />
          <ScheduleCalendar
            shifts={shifts}
            setShifts={setShifts}
            dayShiftBgColor="#B9C2C9"
            nightShiftBgColor="#828C94"
          />
        </ScheduleSection>
      </Col>
    </Row>
  );
};

export default BreakingTimesStep;
